import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import "../styles/Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation("common");

  const isInnerPage = location.pathname !== "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isScrolled = scrolled || isInnerPage;

  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = "";
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const links = [
    { label: t("nav.home"),     href: "/#homepage" },
    { label: t("nav.services"), href: "/#servicos"  },
    { label: t("nav.clients"),  href: "/#clientes"  },
    { label: t("nav.about"),    href: "/#sobre"     },
    { label: t("nav.contact"),  href: "/#cta"       },
  ];

  return (
    <header className={`navbar ${isScrolled ? "navbar--scrolled" : ""} ${menuOpen ? "navbar--open" : ""}`}>
      <div className="navbar__inner">

        <a href="/#homepage" className="navbar__logo">
          <img src={"./connectmon.png"} alt="Connect" />
        </a>

        <nav className="navbar__links" aria-label={t("aria.navigation")}>
          {links.map((l) => (
            <a key={l.href} href={l.href} className="navbar__link">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="navbar__right">
          <LanguageSwitcher />
          <a href="/contactos" className="navbar__cta">
            {t("nav.cta")}
          </a>
        </div>

        <button
          className={`navbar__burger ${menuOpen ? "navbar__burger--open" : ""}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label={t("aria.toggleMenu")}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile overlay */}
      <div className={`navbar__mobile ${menuOpen ? "navbar__mobile--open" : ""}`}>
        <div className="navbar__mobile-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="navbar__mobile-link"
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="navbar__mobile-bottom">
          <LanguageSwitcher />
          <a href="/contactos" className="navbar__mobile-cta" onClick={() => setMenuOpen(false)}>
            {t("nav.cta")}
          </a>
        </div>
      </div>
    </header>
  );
}
